import PropTypes from 'prop-types';
import { useFeatures } from '../hooks/useFeatures';
import Heading from './Heading';
import Infobox from './Infobox';
import ListItem from './ListItem';
import Tile from './Tile';

export default function Features({ categories, editions, features, categoryFilterTerm, getLabel, searchValue, showLightbox, useListView, isFiltered }) {
	const [filteredPrimaryFeatures, filteredSecondaryFeatures] = useFeatures(features, categoryFilterTerm, searchValue);

	const renderMainFeatures = () => {
		if (categoryFilterTerm === 'all' && searchValue === '' && !isFiltered) {
			if (Object.keys(categories).length) {
				return Object.entries(categories).map(([key, category], index) => {
					if (['all', 'staff_pick'].includes(key)) {
						return null;
					}
					return (
						<>
							<Heading key={index} title={category.title} description={category.desc} type="h3" />
							{renderFeatures(filteredPrimaryFeatures.filter((feature) => feature.primary_category === key))}
						</>
					);
				});
			} else {
				return renderFeatures(filteredPrimaryFeatures);
			}
		} else {
			return renderFeatures(filteredPrimaryFeatures);
		}
	};

	const renderFeatures = (features) => {
		return useListView ? (
			<ul className="feature-list">
				{features.map((feature, index) => (
					<ListItem key={index} feature={feature} categories={categories} getLabel={getLabel} editions={editions} showLightbox={showLightbox} />
				))}
			</ul>
		) : (
			<div className="tile-grid">
				{features.map((feature, index) => (
					<Tile key={index} feature={feature} categories={categories} />
				))}
			</div>
		);
	};

	return (
		<div className="feature__content">
			<div className="feature__content--primary">
				{filteredPrimaryFeatures.length ? renderMainFeatures(filteredPrimaryFeatures) : <Infobox type="warning">{getLabel('no_entries_desc')}</Infobox>}
			</div>
			{filteredSecondaryFeatures.length > 0 && (
				<div className="feature__content--additional">
					<Heading title={getLabel('additional_title')} description={getLabel('additional_desc')} type="h3" />
					{renderFeatures(filteredSecondaryFeatures)}
				</div>
			)}
		</div>
	);
}

Features.propTypes = {
	categories: PropTypes.object,
	categoryFilterTerm: PropTypes.string,
	editions: PropTypes.array,
	features: PropTypes.array,
	getLabel: PropTypes.func,
	searchValue: PropTypes.string,
	showLightbox: PropTypes.func,
	useListView: PropTypes.bool,
	isFiltered: PropTypes.bool,
};
